import React, { useEffect, useState } from 'react';
import { useV3Api } from './api/useV3Api';
import { RouteTableContext } from './RouteTableContext';

// Fetches the route table once, after sign-in. If it cannot be read the pages still work, and the "PowerShell" button says it has no
// command to show.
export function RouteTableProvider({ children }) {
  const { get } = useV3Api();
  const [state, setState] = useState({ routes: [], loaded: false });

  useEffect(() => {
    let cancelled = false;
    get('v3/routes')
      .then((body) => { if (!cancelled) setState({ routes: (body && body.items) || [], loaded: true }); })
      .catch(() => { if (!cancelled) setState({ routes: [], loaded: true }); });
    return () => { cancelled = true; };
  }, [get]);

  return <RouteTableContext.Provider value={state}>{children}</RouteTableContext.Provider>;
}
